import { baseEmailAssets, baseEmailTheme, TenantInfo } from '../common';
import { tos } from './tos';

export const tenant = {
  id: 'pelicargo',
  name: 'Pelicargo',
  isSystemTenant: true,
  domains: ['localhost', 'local.env', 'pelicargo.dev', 'peli.demo.pelicargo.dev'],
  customerTheme: {
    colors: {
      primary: {
        '50': '#FFF7E5',
        '100': '#FEEECB',
        '200': '#FDD997',
        '300': '#F9BC63',
        '400': '#F4A03D',
        '500': '#ED7500',
        '600': '#CB5A00',
        '700': '#AA4200',
        '800': '#892F00',
        '900': '#712100',
      },
    },
    logoDims: {
      height: 19,
      width: 194,
    },
    fullLogoDims: {
      height: 19,
      width: 194,
    },
  },
  emailTheme: baseEmailTheme,
  emailAssets: {
    ...baseEmailAssets,
    logo: 'https://raw.githubusercontent.com/pelicargo/assets/master/logo-symbol.png',
    'logo-dark': 'https://raw.githubusercontent.com/pelicargo/assets/master/logo-dark.png',
    'logo-light': 'https://raw.githubusercontent.com/pelicargo/assets/master/logo-symbol.png',
    'logo-dark-tagline': 'https://raw.githubusercontent.com/pelicargo/assets/master/logo-dark.png',
    'logo-light-tagline': 'https://raw.githubusercontent.com/pelicargo/assets/master/logo-light.png',
    twitterUrl: 'https://twitter.com/pelicargo/',
    facebookUrl: 'https://www.facebook.com/pelicargo/',
    linkedinUrl: 'https://www.linkedin.com/company/pelicargo/',
    siteUrl: 'https://www.pelicargo.com',
  },
  admin: {
    cruds: {
      accounts: true,
      providers: true,
      airports: true,
      contacts: true,
      instructions: true,
      users: true,
      backlogs: true,
      surcharges: true,
      rates: true,
      'route-editor': true,
      configuration: true,
    },
    inbox: {
      requestDrawers: {
        // Provider Facing
        ProviderQuoting: true,
        AirlineBooking: true,
        RequestSchedule: true,
        BookingChange: true,
        BookingCancel: true,

        // Customer Facing
        QuoteUpdate: true,
        BookingConfirmation: true,
        NewRate: true,
        RequestClarifications: true,
        Contact: true,
        GenericEmailToFF: true,
        StatusUpdate: true,
      },
    },
    features: {
      instructionCreation: true,
    },
  },
  accountTypes: {
    IATA: true,
    IAC: true,
    ORGANIZATION: true,
    UNCERTIFIED: true,
  },
  customer: {
    supportChat: true,
  },
  termsOfService: tos,
} as const satisfies TenantInfo<'pelicargo'>;
